











import Vue from 'vue'
import RoundButton from '@/components/atoms/RoundButton.vue'
import CenterModal from '@/components/molecules/CenterModal.vue'

export default Vue.extend({
  name: 'ConfirmModal',
  components: {
    RoundButton,
    CenterModal
  },
  props: {
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: false,
      default: ''
    },
    buttonText: {
      type: String,
      required: true
    }
  },
  methods: {
    handleConfirmClick() {
      this.$emit('handleConfirmClick')
    },
    handleCancelClick() {
      this.$emit('handleCancelClick')
    }
  }
})
